import { TiArrowDown, TiArrowUp } from "react-icons/ti";
import styled, { css } from "styled-components";

const CSSASC = css`
    svg:first-child {
        color: #000;
    }
    svg:last-child {
        color: #ccc;
    }
`;

const CSSDESC = css`
    svg:first-child {
        color: #ccc;
    }
    svg:last-child {
        color: #000;
    }
`;

const StyledOrderIcon = styled.span<{ $order: "ASC" | "DESC" }>`
    color: #888;
    display: flex;
    font-size: 1.2em;
    flex-direction: row;

    svg:last-child {
        margin-left: -.5em;
    }

    ${ ({ $order }) => ({ ASC: CSSASC, DESC: CSSDESC }[$order]) }
`;

export default function OrderIcon(props) {
    const { order, ...restProps } = props;
    return (
        <StyledOrderIcon $order={ order } { ...restProps }>
            <TiArrowUp />
            <TiArrowDown />
        </StyledOrderIcon>
    );
}
